<template>
	<div
		class="g-block-body-bracket-line g-block-body-padding"
		:class="{
			'g-block-body-bracket-line--edit': editable,
			'is-active': editable && active,
			'g-block-body-bracket-line--h5': h5,
			'g-block-body-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-body-bracket-line__card">
			<div class="g-block-body-bracket-line__head">
				<RichTextEditable
					v-if="editable"
					class="g-block-body-bracket-line__title"
					fit-content
					:model-value="data.title"
					placeholder="请输入标题"
					@update:model-value="onTitleUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-body-bracket-line__title"
					v-html="data.title || ''"
				></div>
				<span
					class="g-block-body-bracket-line__line"
					:style="{ background: lineColor }"
					aria-hidden="true"
				></span>
			</div>
			<RichTextEditable
				v-if="editable"
				class="g-block-body-bracket-line__text"
				:model-value="data.content"
				placeholder="请输入正文"
				@update:model-value="onContentUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-body-bracket-line__text"
				v-html="data.content || ''"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { getTitleThemeColor } from '../../../templates.js';
	import { bodyCardMixin } from '../shared/bodyCardMixin.js';

	const DEFAULT_LINE_COLOR = '#dcdfe6';

	export default {
		name: 'GBlockBodyBracketLine',
		components: { RichTextEditable },
		mixins: [bodyCardMixin],
		computed: {
			lineColor() {
				if (this.data?.color) {
					return getTitleThemeColor(this.data);
				}
				return DEFAULT_LINE_COLOR;
			},
		},
	};
</script>

<style scoped lang="less">
	@import '../shared/bodyEditShell.less';
	@import '../shared/lineDotCard.less';

	.g-block-body-bracket-line {
		.body-block-edit-shell();
	}

	.g-block-body-bracket-line__card {
		.line-dot-card-shell();
	}

	.g-block-body-bracket-line__head {
		.line-dot-card-head();
	}

	.g-block-body-bracket-line__title {
		.line-dot-card-title();
		color: #333;

		:deep(.g-rich-text-editable__content) {
			color: #333;
		}
	}

	.g-block-body-bracket-line__line {
		.line-dot-card-line();
		flex: 1;
	}

	.g-block-body-bracket-line__text {
		.line-dot-card-text();
		color: #666;

		:deep(.g-rich-text-editable__content) {
			color: inherit;
		}
	}

	.g-block-body-bracket-line--h5 {
		.g-block-body-bracket-line__card {
			.line-dot-card-shell--h5();
		}
		.g-block-body-bracket-line__head {
			.line-dot-card-head--h5();
		}
		.g-block-body-bracket-line__line {
			.line-dot-card-line--h5();
		}
		.line-dot-card-title--h5(~'.g-block-body-bracket-line__title');
		.body-text-base--h5(~'.g-block-body-bracket-line__text');
	}
</style>
